import React from "react";
import { Dna, Zap } from "lucide-react";
import BasketballIcon from "./BasketballIcon";

export const GOLD = "#d8b854";
const BG = "#141414";

// Three color-coded emblems — shield (DNA · gold), round patch (On Court · electric blue), hexagon (Physical · emerald) — over a tinted banner naming the category.
export const BADGE_THEMES = {
  DNA: { color: "#d8b854", Icon: Dna, label: "DNA",
    path: "M32 3 L55 10 V30 C55 42 46 51 32 57 C18 51 9 42 9 30 V10 Z",
    inner: "M32 9.5 L49.5 15 V30 C49.5 39.5 42.5 47 32 51.5 C21.5 47 14.5 39.5 14.5 30 V15 Z" },
  "On Court": { color: "#3d9cff", Icon: BasketballIcon, label: "ON COURT",
    path: "M32 4 A23 23 0 1 1 31.9 4 Z",
    inner: "M32 10 A17 17 0 1 1 31.9 10 Z" },
  Physical: { color: "#34d399", Icon: Zap, label: "PHYSICAL",
    path: "M32 3 L55 16 V44 L32 57 L9 44 V16 Z",
    inner: "M32 9.5 L49.5 19.5 V40.5 L32 50.5 L14.5 40.5 V19.5 Z" },
};
const BANNER = "M4 50 H60 L56 63 H8 Z";
export const badgeTheme = (category) => BADGE_THEMES[category] || BADGE_THEMES["On Court"];

export default function BadgeEmblem({ category, size = 72, className = "", glow = true }) {
  const t = badgeTheme(category);
  const Icon = t.Icon;
  const iconPx = Math.round(size * 0.34);
  const showLabel = size >= 36;
  const gid = `bg-${t.label.replace(/\s+/g, "")}`;
  return (
    <div className={`relative shrink-0 ${className}`} style={{ width: size, height: size * 1.125, filter: glow ? `drop-shadow(0 0 ${Math.round(size / 7)}px ${t.color}55)` : undefined }}
      data-testid={`badge-emblem-${(category || "").toLowerCase().replace(/\s+/g, "-")}`}>
      <svg viewBox="0 0 64 72" width={size} height={size * 1.125} className="absolute inset-0" aria-hidden="true">
        <defs>
          <radialGradient id={gid} cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor={t.color} stopOpacity="0.38" />
            <stop offset="100%" stopColor={t.color} stopOpacity="0.08" />
          </radialGradient>
        </defs>
        <path d={t.path} fill={BG} stroke={t.color} strokeWidth="2" strokeLinejoin="round" />
        <path d={t.path} fill={`url(#${gid})`} />
        <path d={t.inner} fill="none" stroke={t.color} strokeWidth="0.75" opacity="0.5" strokeLinejoin="round" />
        <path d={BANNER} fill={t.color} stroke={BG} strokeWidth="1.5" strokeLinejoin="round" />
        {showLabel && (
          <text x="32" y="59.6" textAnchor="middle" fill={BG} fontFamily="Montserrat, sans-serif" fontWeight="800" fontSize="6.2" letterSpacing="0.35">{t.label}</text>
        )}
      </svg>
      <Icon className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2" style={{ top: "37%", width: iconPx, height: iconPx, color: t.color }} strokeWidth={1.9} />
    </div>
  );
}
